<template>
  <div class="modal" :class="{ 'is-active': showModalEvent }" v-if="label">
    <div class="modal-background" @click="hideModal(true)"></div>
    <div class="modal-content">
      <div class="box">
        <div class="title">
          {{this.showCreationForm ? label.titles.createEvent : label.titles.editEvent}}
        </div>

        <form @submit.prevent="submitEventForm">
          <!-- date -->
          <div class="field">
            <label class="label">{{label.forms.date}}</label>
            <div class="control">
              <VueDatePicker
                v-model="eventForm.date"
                input-class="input"
                auto format="dd-MM-yyyy"
                :minDate="threeYearsAgo"
                timezone="Europe/Brussels"
                locale="fr"
                :selectText="label.buttons.confirm"
                :cancelText="label.buttons.cancel"
                :enableTimePicker="false"
                weekStart='1'
                :hideInputIcon="true"
                :auto-apply="true"
              >
              </VueDatePicker>
            </div>
          </div>

          <!-- catégorie -->
          <div class="field">
            <label class="label">{{label.forms.category}}</label>
            <div class="control">
              <div class="dropdown" :class="{'is-active': categoryDropActive}">
                <div class="dropdown-trigger">
                  <button
                    class="button"
                    type="button"
                    @click="categoryDropActive = !categoryDropActive"
                    @blur="categoryDropActive = false">
                    <span>{{eventForm.category}}</span>
                    <span class="icon is-small"><awesome-icon icon="angle-down" aria-hidden="true"/></span>
                  </button>
                </div>
                <div class="dropdown-menu " role="menu">
                  <div class="dropdown-content">
                    <a
                      class="dropdown-item"
                      v-for="category of categories"
                      :key="category"
                      @mousedown="eventForm.category = category"
                    >
                      {{category}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- type -->
          <!-- <div class="field">
            <label class="label">{{label.forms.type}}</label>
            <div class="control">
              <input class="input input-medium" type="text" v-model="eventForm.type">
            </div>
          </div> -->

          <!-- description -->
          <div class="field">
            <label class="label">{{label.forms.description}}</label>
            <div class="control">
              <input class="input input-medium" type="text" maxlength="400" v-model="eventForm.description">
            </div>
          </div>

          <!-- Confirm/Cancel -->
          <div class="field is-grouped">
            <p class="control">
              <button class="button is-primary" type="submit">{{label.buttons.save}}</button>
            </p>
            <p class="control">
              <a class="button is-light" @click="hideModal(true)">{{label.buttons.cancel}}</a>
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { EventService } from '../services'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment-timezone'

export default {
  components: {
    VueDatePicker
  },
  props: ['openModal', 'showCreationForm', 'reloadData', 'locationID', 'event', 'closeModal'],
  data() {
    return {
      categories: ['Travaux', 'Energie', 'Achat', 'Famille',  'Autre'],
      eventForm: null,
      categoryDropActive: false,
      showModalEvent: false,
    }
  },
  computed: {
    ...mapState("account", ["user"]),
    ...mapState({ label: state => state.labels.myEvents }),
    threeYearsAgo() {
      return moment().startOf('day').subtract(3, 'years').toDate().toISOString()
    }
  },
  methods: {
    ...mapActions("labels", ["getLabel"]),
    resetForm() {
      this.eventForm = {
        date: moment().startOf('day').toDate().toISOString(),
        category: this.categories[0],
        type: '',
        description: ''
      }
    },
    submitEventForm() {
      if(this.showCreationForm) {
        EventService.addEvent(this.eventForm, this.locationID)
        .then(() => {
          this.resetForm()
          this.showModalEvent = false
          this.reloadData('addEvent')
        })
      }
      else {
        EventService.modifyEvent(this.eventForm)
        .then(() => {
          this.resetForm()
          this.showModalEvent = false
          this.reloadData('editEvent')
        })
      }
    },
    hideModal(isCancelled) {
      this.showModalEvent = false;
      this.closeModal(isCancelled)
    },
  },
  created() {
    moment.tz.setDefault("Europe/Brussels")
    this.resetForm()
    this.getLabel({ view: 'myEvents' })
  },
  watch: {
    openModal() {
      if (this.openModal) {
        this.resetForm()
        if (!this.showCreationForm) {
          this.eventForm = this.event
        }
        this.showModalEvent = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
form {
  min-height: calc(35vh);
}
.field:not(:last-child) {
   margin-bottom: 2rem;
}
</style>